/**
 * this is the global toast service
 **/
export default class ToastService {
  /**
   * define required services here
   * @param {function} - $injector to inject all services
   **/
   constructor($injector) {
       this.$mdToast = $injector.get('$mdToast');
   }

   /**
   * normal toast
   * @param {string} text - message
   * @param {string} position - position of the toast
   * @param {string} theme - theme
   * @param {number} delay - delay
   **/
   toast(text, position = 'top right', theme = '', delay = 5000){
       let toast = this.$mdToast.simple();
       toast.textContent(text);
       toast.position(position);
       toast.theme(theme);
       toast.hideDelay(delay);

       this.$mdToast.show(toast);
   }

   /**
   * danger toast
   * @param {string} text - message
   * @param {string} position - position of the toast
   **/
   danger(text, position = 'top right'){
      this.action(text, 'ok', this.hide, position, 0, 'danger-toast');
   }

   /**
   * action toast
   * @param {string} text - message
   * @param {string} action - description of the action
   * @param {function} actionCallback - callback function to execute
   * @param {string} position - position of the toast
   * @param {number} delay - delay
   * @param {string} theme - theme
   **/
   action(text, action, actionCallback, position = 'top right', delay = 0, theme = ''){
      let toast = this.$mdToast.simple();
      toast.textContent(text);
      toast.position(position);
      toast.theme(theme);
      toast.hideDelay(delay);
      toast.action(action);
      toast.highlightAction(true);

      this.$mdToast.show(toast).then((response) => {
        if (response == 'ok') {
            actionCallback(true, this.$mdToast);
        }
      });
   }

  /**
   * hide toast
   * @param {boolean} response - An argument for the resolved promise.
   **/
  hide(response = true, toastrInstance = null) {
      if (toastrInstance !== null) {
          toastrInstance.hide(response);
      } else { // eigentlich muesste man da auch noch this.$mdToast pruefen und ggf. logging einbauen
          this.$mdToast.hide(response);
      }
  }
}
